export const ADD_APP_TO_IFRAME = 'ADD_APP_TO_IFRAME'
export const SELECTED_APP_TO_IFRAME = 'SELECTED_APP_TO_IFRAME'
export const REMOVE_APP_FROM_IFRAME = 'REMOVE_APP_FROM_IFRAME'
export const UPDATE_APP_FROM_IFRAME = 'UPDATE_APP_FROM_IFRAME'
export const UPDATE_IFRAME_APP_URL = 'UPDATE_IFRAME_APP_URL'
